<template>
  <div class="table-container">
  <perfect-scrollbar @ps-y-reach-end="check" ref="scroll"  @ps-scroll-y="check">

  <table>

    <tr class="header-table">
      <td>زمان و تاریخ</td>
      <td>آی پی(IP)</td>
      <td class="hide-768">نوع دستگاه</td>
      <td  class="hide-400">پلتفرم</td>
      <td class="hide-768">مرورگر</td>
      <td>وضعیت</td>
    </tr>



    <tr  v-for="(item , index) in tableContents" :key="index+1">
      <td><span> {{$G2J(item.loginRequestedDateTime,'faDateTime')}}</span></td>
      <td><span>{{ item.ipAddress }}</span></td>
      <td class="hide-768"><span>{{ item.deviceType }}</span></td>
      <td class="hide-400"><span>{{ item.osType }}</span></td>
      <td class="hide-768"><span>{{ item.browser }}</span></td>
      <td><span :class="{'green':item.isSuccessful === true , 'red':item.isSuccessful === false}">{{ item.isSuccessful ? 'موفق':'ناموفق' }}</span></td>
    </tr>



  </table>

  </perfect-scrollbar>
  </div>
</template>

<script>
export default {
  name: "loginHistory",
  data() {
    return {
       lastPage: 1,
      tableContents: [],
      page: 0,
      loading: false,
      loginheader: ['زمان و تاریخ', 'آی پی(IP)', 'نوع دستگاه', 'پلتفرم', 'مرورگر', 'وضعیت'],
      //login history data

    }
  },
    methods:{
    async check() {
      // this.state.loading=true;
      if (this.page <= this.lastPage && !this.loading) { //for scroll loading
        this.loading = true
        this.page++ //for scroll loading
        const [res, ] = await this.$http.get('/users/login-history', {
          params: {
            size: 10,
            page: this.page
          }
        })
        if (res) {
          this.lastPage = res.totalPages
          this.tableContents = [...this.tableContents, ...res.content] //for scroll loading
          // this.tableContents = res.content //for pagination
        }
        this.loading = false
      }
    },
  },
  mounted() {
    this.check()

  }
}
</script>

<style lang="scss" scoped>
.table-container{
  height: 300px;
  overflow-y: scroll;
}

// tr{
//   width: 100%;
// }


table {
  table-layout: fixed;
  // overflow: none !important;

  th {
    font-size: clamp(10px , 1vw , 14px);
    color: #D7C8C8;
    background-color: #091222;
    text-align: center;

    &:first-child {
      text-align: right !important;
    }

    &:last-child {
      text-align: left !important;
    }
  }

  td {
    font-size: clamp(10px , 1vw , 14px);
    color: #D7C8C8;
    height: 40px;
    text-align: center;

    &:first-child {
      text-align: right !important;
    }

    &:last-child {
      text-align: left !important;
    }
  }
  .body{
    width: 100%;
  }

  .header-table {
    height: 65px;
    position: sticky;
    top: 0;
    background: linear-gradient(180deg, #091222 0%, #0A1425 100%);

    &:first-child {
      text-align: right;
    }

    &:last-child {
      text-align: left;
    }
  }

  .body {
    &:first-child {
      text-align: right;
    }

    &:last-child {
      text-align: left;
    }
  }
}

@media (max-width: 992px) {
  .hide-992{
    display:none !important;
  }
}

@media (max-width: 768px) {
  .hide-768{
    display:none !important;
  }
}

@media (max-width: 400px) {
  .hide-400{
    display:none !important;
  }
}
</style>